/**
 * bundle-linker.js
 *
 * Links product add-ons (flocage, flocage bas, badges/patches) to their parent jersey
 * so the cart behaves like a real bundle:
 *   - Removing the jersey removes ITS add-ons too.
 *   - With several jerseys, removing one only removes that jersey's add-ons.
 *
 * How it works:
 *  1. At add-to-cart, the theme's <form is="product-form"> sends a JSON items array
 *     (parent jersey + each checked add-on). We patch prepareFormData to stamp a shared,
 *     unique group id: the parent gets properties._bundle, each add-on gets properties._addon.
 *     (Underscore-prefixed properties are hidden from the customer in cart/checkout.)
 *  2. A reconciler subscribes to the theme's cartUpdate event. After any cart change it
 *     fetches the cart and removes any add-on line whose parent (_bundle) is no longer present.
 */
(function () {
  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  }

  // Paid add-ons a jersey line expects, derived from the option summary shown on the
  // jersey (Flocage / Flocage bas / BADGES 1 / BADGES 2). Used to re-add a paid line a
  // customer deletes from the cart while the jersey still declares the option — so you
  // can't get flocage/badges for free. To cancel an option the customer unticks it on
  // the product page.
  var FLOCAGE_VARIANT = '60241602511182';
  var FLOCAGE_BAS_VARIANT = '60241602576718';
  var BADGE_MAP = {
    "Ligue 1": '60241602675022',
    "Ligue 1 Winner": '60241602969934',
    "Champions League": '60241603068238',
    "Europa League": '60241603199310',
    "Trophée des Champions": '60241603264846',
    "Coupe de France": '60241603363150',
    "Champions League Winner": '60241603428686',
    "Club World Cup 2025": '60241603494222',
    "BADGE D&P": '60241603559758',
    "Etoiles ⭐⭐": '60241602609486',
    "LIGA": '60241603625294',
    "Champions League x15": '60241604215118',
    "Champions League x5": '60241604313422',
    "Intercontinental Champions 2024": '60241604378958',
    "Premier League": '60241603592526',
    "FA Cup": '60241604116814',
    "Carabao Cup": '60241604182350',
    "Winner Club World Cup 2025": '60241604477262',
    "Seria A": '60241603690830',
    "Bundesliga": '60241604018510',
    "Bundesliga Winner": '60241604084046',
    "Champions League x6": '60241604346190',
    "BADGE UEFA NATIONS LEAGUE + FOUNDATION FOR CHILDREN 10 YEARS ANNIVERSARY": '60241604903246',
    "BADGE 2026 WORLD CUP": '60241604575566',
    "Winner UEFA Nations League": '60241604837710',
    "WORLD CUP 2026": '60241604608334',
    "WORLD CUP WINNERS": '60241604772174'
  };

  function expectedAddonVariants(props) {
    var out = [];
    if (!props) return out;
    if (props['Flocage'] === 'Oui') out.push(FLOCAGE_VARIANT);
    if (props['Flocage bas'] === 'Oui') out.push(FLOCAGE_BAS_VARIANT);
    ['BADGES 1', 'BADGES 2'].forEach(function (k) {
      var name = props[k];
      if (name && name !== 'Aucun' && BADGE_MAP[name]) out.push(BADGE_MAP[name]);
    });
    return out;
  }

  /* 1) Stamp parent/add-on group ids at add-to-cart time. */
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('product-form').then(function () {
      var ProductForm = customElements.get('product-form');
      if (!ProductForm || !ProductForm.prototype || ProductForm.prototype.__bundleLinked) return;
      var original = ProductForm.prototype.prepareFormData;
      if (typeof original !== 'function') return;

      ProductForm.prototype.prepareFormData = function (formData) {
        var result = original.call(this, formData);
        try {
          if (result && Array.isArray(result.items) && result.items.length > 1) {
            var items = result.items;
            var mainIndex = items.length - 1;
            // Keep the main product (last item) + only add-ons whose id is a valid
            // numeric variant id. Drops checkboxes a browser wrongly restored as checked
            // (id "" or "on"), which would otherwise cause "Cannot find variant".
            var cleaned = items.filter(function (it, i) {
              if (i === mainIndex) return true;
              return it && /^[0-9]+$/.test(String(it.id));
            });
            result.items = cleaned;
            if (cleaned.length > 1) {
              var groupId = 'b' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
              var parent = cleaned[cleaned.length - 1];
              parent.properties = parent.properties || {};
              parent.properties._bundle = groupId;
              for (var i = 0; i < cleaned.length - 1; i++) {
                cleaned[i].properties = cleaned[i].properties || {};
                cleaned[i].properties._addon = groupId;
              }
            }
          }
        } catch (e) {
          /* never block add-to-cart */
        }
        return result;
      };
      ProductForm.prototype.__bundleLinked = true;
    });
  }

  /* Reset our option controls on load / bfcache restore. Browsers can restore a
     previously-checked state (re-adding options the customer didn't pick), so we force
     them back to the unselected state shown on the page. */
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('.badge-picker__bundle').forEach(function (cb) {
      cb.checked = false;
      cb.value = '';
    });
    document.querySelectorAll('badge-picker [data-badge-text]').forEach(function (t) {
      t.textContent = '— Aucun —';
    });
    document.querySelectorAll('badge-picker [data-badge-thumb]').forEach(function (t) {
      t.hidden = true;
    });
    document.querySelectorAll('[data-badge-status]').forEach(function (s) { s.value = 'Aucun'; });
    document.querySelectorAll('[data-fan-toggle]').forEach(function (cb) { cb.checked = false; });
    document.querySelectorAll('flocage-option [data-flocage-toggle]').forEach(function (cb) {
      if (cb.checked) {
        cb.checked = false;
        cb.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });

  /* 2) Reconcile: drop add-ons whose parent jersey is gone. */
  var reconciling = false;

  function reconcile() {
    if (reconciling) return;

    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items) return;

        // Group the cart by bundle id: parent jersey (has _bundle) + which add-on
        // variants are already present in that group.
        var groups = {};
        cart.items.forEach(function (item) {
          var b = item.properties && item.properties._bundle;
          if (b) groups[b] = { props: item.properties, present: {} };
        });
        cart.items.forEach(function (item) {
          var a = item.properties && item.properties._addon;
          if (a && groups[a]) groups[a].present[String(item.variant_id)] = true;
        });

        var changed = false;

        // Remove add-on lines whose parent jersey is gone.
        var updates = {};
        cart.items.forEach(function (item) {
          var a = item.properties && item.properties._addon;
          if (a && !groups[a]) { updates[item.key] = 0; changed = true; }
        });

        // Re-add paid add-ons the jersey still declares but that were deleted.
        var adds = [];
        Object.keys(groups).forEach(function (gid) {
          expectedAddonVariants(groups[gid].props).forEach(function (vid) {
            if (!groups[gid].present[vid]) {
              adds.push({ id: vid, quantity: 1, properties: { _addon: gid } });
              changed = true;
            }
          });
        });

        if (!changed) return;

        reconciling = true;
        var sections = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } })
        );
        var jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };

        var chain = Promise.resolve();
        if (Object.keys(updates).length) {
          chain = chain.then(function () {
            return fetch(root() + 'cart/update.js', { method: 'POST', headers: jsonHeaders, body: JSON.stringify({ updates: updates }) });
          });
        }
        if (adds.length) {
          chain = chain.then(function () {
            return fetch(root() + 'cart/add.js', { method: 'POST', headers: jsonHeaders, body: JSON.stringify({ items: adds }) });
          });
        }
        return chain
          .then(function () {
            // Final call gets the freshly-rendered cart sections for the UI.
            return fetch(root() + 'cart/update.js', {
              method: 'POST',
              headers: jsonHeaders,
              body: JSON.stringify({ updates: {}, sections: sections, sections_url: window.location.pathname })
            });
          })
          .then(function (r) { return r.json(); })
          .then(function (parsed) {
            if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
              theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'bundle-linker', cart: parsed });
            } else {
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: parsed } }));
            }
          });
      })
      .catch(function () { /* no-op */ })
      .finally(function () { reconciling = false; });
  }

  function init() {
    if (!(window.theme && theme.pubsub && theme.pubsub.subscribe && theme.pubsub.PUB_SUB_EVENTS)) {
      return setTimeout(init, 200);
    }
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'bundle-linker') return; // ignore our own update (avoid loops)
      reconcile();
    });
    // Clean up any add-ons left orphaned in the cart (e.g. from earlier tests).
    reconcile();
  }
  init();
})();
